<script setup lang="ts">
import { onMounted } from 'vue';

import { AppInfoBox } from '@libs/ui';
import { performanceMark } from '@libs/utils';

import type { HotelSelectionCardData } from '../models';
import { useHotelSelectionListStore } from '../stores/hotelSelection/hotelSelectionListStore';

import HotelSelectionDynamicScroller from './HotelSelectionDynamicScroller.vue';

interface HotelSelectionListProps {
  data: HotelSelectionCardData[];
  isMobile?: boolean;
}

const props = defineProps<HotelSelectionListProps>();

interface HotelSelectionListEmits {
  (eventName: 'hightlight-on-map', hotelCode: string | undefined): void;
  (eventName: 'initialized-hotel-selection-list'): void;
}

const emit = defineEmits<HotelSelectionListEmits>();

const hotelSelectionListStore = useHotelSelectionListStore();

onMounted(() => {
  if (hotelSelectionListStore.isFirstHotelSelectionListRender) {
    if (props.data.length) {
      performanceMark('HotelSelectionListRendered');
    }
    hotelSelectionListStore.isFirstHotelSelectionListRender = false;
  }
});
</script>

<template>
  <div class="hotel-selection-list">
    <HotelSelectionDynamicScroller
      v-if="props.data.length"
      :data="props.data"
      :is-mobile="props.isMobile"
      @hightlight-on-map="emit('hightlight-on-map', $event)"
      @initialized-hotel-selection-list="
        emit('initialized-hotel-selection-list')
      "
    />
    <AppInfoBox v-else :text="$t('planner.no_accommodation_available')" />
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-list {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
